var _ = require("lodash");
var Forms = require('../framework/Forms');

Forms.addFormType("GameFrame",
	form => Forms.isEmpty(form.subform),
	form => Forms.isEffectivelyEmpty(form.subform),
	(form, move) => Forms.match(form.subform, move));

Forms.addFormType("AutoFinish",
() => false,
() => false,
() => true);

Forms.addFormType("Comics",
	() => false,
	() => false,
	() => true);

Forms.addFormType("Tree",
	() => false,
	() => false,
	() => true);

Forms.addFormType("Greeting",
	() => false,
	() => false,
	() => true);

Forms.addFormType("Question",
	() => false,
	() => false,
	({ options }, move) => 0 <= move && move < options.length);

Forms.addFormType("Intro",
	() => false,
	() => false,
	() => true);

Forms.addFormType("YesNoMinigame",
	_.constant(false),
	_.constant(false),
	(form, move) => move === true || move === false);

	Forms.addFormType("SelectPicMinigame",
	_.constant(false),
	_.constant(false),
	(form, move) => 0 <= move && move < form.options.length);

Forms.addFormType("SelectManyPicsMinigame",
	_.constant(false),
	_.constant(false),
	(form, move) => move instanceof Array && move.length <= form.options.length && _.every(move, (x) => 0 <= x && x < form.options.length));

Forms.addFormType("ManyAnsQuestion", 
	_.constant(false), 
	_.constant(false), 
	({ options }, move) => 0 <= move && move < options.length);

Forms.addFormType("MatchPicsMinigame",
	_.constant(false),
	_.constant(false),
	(form, move) => move instanceof Array && move.length === form.line1.length && _.every(move, (x) => 0 <= x && x < form.line2.length));

Forms.addFormType("OrderListMinigame",
	_.constant(false),
	_.constant(false),
	(form, move) => move instanceof Array && move.length === form.line1.length && _.every(move, (x) => 0 <= x && x < form.line2.length));

Forms.addFormType("PaintBoxesMinigame",
	_.constant(false),
	_.constant(false),
	(form, move) => move instanceof Array && move.length === form.line1.length && _.every(move, (x) => 0 <= x && x < form.line2.length));

Forms.addFormType("References",
	_.constant(false),
	_.constant(false),
	() => true);

Forms.addFormType("Final",
	_.constant(false),
	_.constant(false),
	() => true);

Forms.addFormType("End",
	_.constant(false),
	_.constant(false),
	() => true);

Forms.addFormType("Menu", _.constant(false), _.constant(false), _.constant(true));